import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type NotificationItemDTO = {
  id: string
  type: "ZM" | "ZZ" | "ZAP" | string
  document_id: string
  document_number: string
  event_at: string
  text: string
  read_at?: string | null
  stream_sequence?: number
}

export type NotificationPreferenceItemDTO = {
  type: string
  enabled: boolean
  title?: string
  description?: string
}

export const NotificationsService = {
  getAll: (
    after?: string,
    limit?: number,
  ): CancelablePromise<NotificationItemDTO[]> =>
    __request(OpenAPI, {
      method: "GET",
      url: "/v1/notifications",
      query: { after, limit },
    }),

  getPreferences: (): CancelablePromise<NotificationPreferenceItemDTO[]> =>
    __request(OpenAPI, {
      method: "GET",
      url: "/v1/notifications/preferences",
    }),

  updatePreferences: (
    preferences: NotificationPreferenceItemDTO[],
  ): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "PUT",
      url: "/v1/notifications/preferences",
      body: { preferences },
      mediaType: "application/json",
    }),

  markRead: (ids: string[]): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/notifications/read",
      body: { ids },
      mediaType: "application/json",
    }),

  markReadAll: (until: string): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/notifications/read-all",
      body: { until },
      mediaType: "application/json",
    }),

  dismiss: (ids: string[]): CancelablePromise<void> =>
    __request(OpenAPI, {
      method: "POST",
      url: "/v1/notifications/dismiss",
      body: { ids },
      mediaType: "application/json",
    }),
}
